import { VehicleActionsComponent } from './vehicle.actions.component';

export function VehiclesCtrl (
  $scope,
  inheritorApi,
  vehicles
) {
  $scope.vehicles = vehicles;

  inheritorApi.inheritCtrl('VehiclesLiteCtrl', $scope);

  $scope.tableSettings.columns[$scope.tableSettings.columns.length -1] = {
    component: {
      bindings: {
        outputs: {
          onEditClick   : event => $scope.viewVehicle(event),
          onBookingClick: event => $scope.createBooking(event),
          onInvoiceClick: event => $scope.createInvoice(event)
        }
      },
      enabled: true,
      factory: VehicleActionsComponent,
    },
    sortable: false,
  };
};